import { useRef, useEffect } from "react";

export function usePrevious<T>(value: T) {
	const ref = useRef<T>();

	// useEffect fires after component render
	// So component returns value before new value is set to ref
	useEffect(() => {
		ref.current = value;
	}, [value]); // Only re-run if value changes

	// Return previous value (happens before update in useEffect above)
	return ref.current;
}
